module.exports = __webpack_public_path__ + "static/media/MigrateIcon.28a9cc39.svg";